import { fetchCompetitorLogosBatch, mapCompetitorsWithLogoAndDescription } from "@/store/utils/fetchCompetitorLogos";
import { Company, CompetitorsResponse } from "../types";
import { call, put } from "redux-saga/effects";
import { fetchCompetitorsRegisterFailed, fetchCompetitorsRegisterSuccess, setCompetitorsRegisterLoading } from "../slice";
import { fetchCompetitorsSaga } from "@/store/utils/apiScoresSagas";
import { applySagaError } from "@/store/utils/saga";
import analytics from "@/lib/Analytics";
import { PayloadAction } from "@reduxjs/toolkit";

export function* fetchCompetitorsRegisterSaga(action: PayloadAction<Company>) {
  try {
    yield put(setCompetitorsRegisterLoading());
    const brand = action.payload;

    const data: CompetitorsResponse = yield call(fetchCompetitorsSaga, brand);

    if (!data.competitors?.length) {
      yield put(fetchCompetitorsRegisterSuccess([]));
      return;
    }

    analytics.track('Competitors suggested', {
      brand: brand.name,
      competitors: data.competitors.map((item) => item.name).join(',')
    });

    // Save brand to user profile
    analytics.setUserProperties({
      brand: brand.name
    });

    const logosMap: Awaited<ReturnType<typeof fetchCompetitorLogosBatch>> = yield call(
      fetchCompetitorLogosBatch,
      data.competitors
    );

    const competitorsWithLogo = mapCompetitorsWithLogoAndDescription(
      data.competitors,
      logosMap,
    );

    yield put(fetchCompetitorsRegisterSuccess(competitorsWithLogo));
  } catch (error) {
    yield* applySagaError(error, {
      operationName: "auth.fetchCompetitorsRegister",
      failureAction: fetchCompetitorsRegisterFailed,
    });
  }
}